module.exports = __webpack_public_path__ + "static/media/206.7f08102b.png";